import { useState, useEffect } from 'react';
import { sessionService, loginUser, logoutUser, validateSession } from '../services/api';

export const useAuth = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Check if user is logged in on initial load
    const sessionId = sessionService.getSessionId();
    const storedUser = localStorage.getItem('ssUser');

    setIsAuthenticated(!!sessionId);
    if (storedUser) {
      try {
        setUser(JSON.parse(storedUser));
      } catch (error) {
        console.error('Error parsing stored user:', error);
      }
    }
    setIsLoading(false);
  }, []);

  const login = async (username, password) => {
    try {
      const response = await loginUser(username, password);

      setIsAuthenticated(true);

      // Update user state
      if (response.data?.user) {
        setUser(response.data.user);
      }

      return response;
    } catch (error) {
      throw error;
    }
  };

  const logout = async () => {
    try {
      // Call backend logout endpoint
      await logoutUser();
    } catch (error) {
      console.error('Logout error:', error);
    } finally {
      // Always clear local session
      sessionService.clearSessionId();
      setIsAuthenticated(false);
      setUser(null);
    }
  };

  const validate = async () => {
    try {
      const response = await validateSession();
      setIsAuthenticated(response.valid);
      return response;
    } catch (error) {
      console.error('Session validation error:', error);
      setIsAuthenticated(false);
      setUser(null);
      throw error;
    }
  };

  return {
    isAuthenticated,
    isLoading,
    user,
    login,
    logout,
    validate
  };
};